import BaseService from './base.service'

class EtapasDaFormacaoService extends BaseService {
  constructor() {
    super({ resource: 'EtapaDaFormacao' })
  }
}

const etapasDaFormacaoService = new EtapasDaFormacaoService()

export default etapasDaFormacaoService
